import { LOYATY_ACCOUNT_DATA_EXPIRY } from 'common/constants/local-storage-constants';

export const getDatePlusYear = () => new Date(Date.now() + 1000 * 60 * 60 * 24 * 365);
export const getDatePlusHalAnfHour = () => new Date(Date.now() + LOYATY_ACCOUNT_DATA_EXPIRY);
